// Adaptive System
import CheckboxInput from './components/Base/Forms/CheckboxInput';
import RadioInput from './components/Base/Forms/RadioInput';
import InputError from './components/Base/Forms/InputError';
import InputInfo from './components/Base/Forms/InputInfo';
import OnClickOutside from './components/Base/OnClickOutside';
import SearchSelect from './components/Base/Forms/SearchSelect';
import SelectInput from './components/Base/Forms/SelectInput';
import TextInput from './components/Base/Forms/TextInput';
import Submenu from './components/Base/Submenu';
import Toggler from './components/Base/Toggler';
import Alert from './components/Base/Alerts/Alert';
import FlashyAlert from './components/Base/Alerts/FlashyAlert';
import SelectArrow from './components/Base/Forms/SelectArrow';
import BaseMap from './components/Maps/BaseMap';
import AdaptiveFormModal from './components/Base/Modals/AdaptiveFormModal';
import AdaptiveModal from './components/Base/Modals/AdaptiveModal';
import ConfirmModal from './components/Base/Modals/ConfirmModal';

import InformationToggler from './components/Base/InformationToggler';
import ConfirmDeleteButton from './components/Base/ConfirmDeleteButton';
import TextareaInput from './components/Base/Forms/TextareaInput';
import MegaDropdown from './components/MegaDropdown';
import ConfirmDeleteIconButton from './components/Base/ConfirmDeleteIconButton';
import UploadInternalExternalFileButton from './components/UploadInternalExternalFileButton';
import CustomerContactDetails from './components/Customers/CustomerContactDetails';
import ImagePreviewThumbnail from './components/ImagePreviewThumbnail';

import EditOperationInformationItems from '../shared/components/Addresses/EditOperationInformationItems';
import EditSwitchPortButton from '../shared/components/Addresses/EditSwitchPortButton';
import SwitchPortSearch from '../shared/components/Addresses/SwitchPortSearch';
import SwitchSearch from '../shared/components/Addresses/SwitchSearch';
import TaskCompletedBy from '../vendor/laravel-tasks/components/TaskCompletedBy';
import OrderComment from './components/Orders/OrderComment';
import OrderCommentButtonModal from './components/Orders/OrderCommentButtonModal';
import EditSalesAgentButton from './components/Orders/EditSalesAgentButton';
import AddressQueryButton from './components/Addresses/AddressQueryButton';

import SalesPenetrationSteps from './components/SalesPenetrationSteps';

import InvoiceCalculator from './components/InvoiceCalculator';

import ExportSalesPeriod from './components/ExportSalesPeriod.vue';

Vue.component('checkbox-input', CheckboxInput);
Vue.component('radio-input', RadioInput);
Vue.component('input-error', InputError);
Vue.component('input-info', InputInfo);
Vue.component('on-click-outside', OnClickOutside);
Vue.component('search-select', SearchSelect);
Vue.component('select-input', SelectInput);
Vue.component('text-input', TextInput);
Vue.component('submenu', Submenu);
Vue.component('toggler', Toggler);
Vue.component('mega-dropdown', MegaDropdown);
Vue.component('switch-port-search', SwitchPortSearch);
Vue.component('switch-search', SwitchSearch);

// Alerts
Vue.component('alert', Alert);
Vue.component('flashy-alert', FlashyAlert);

// General
Vue.component('select-arrow', SelectArrow);
Vue.component('textarea-input', TextareaInput);
Vue.component('informationToggler', InformationToggler);
Vue.component('confirm-delete-button', ConfirmDeleteButton);
Vue.component('confirm-delete-icon-button', ConfirmDeleteIconButton);
Vue.component('customer-contact-details', CustomerContactDetails);

// Maps
Vue.component('base-map', BaseMap);

// Modal
Vue.component('adaptive-form-modal', AdaptiveFormModal);
Vue.component('adaptive-modal', AdaptiveModal);
Vue.component('confirm-modal', ConfirmModal);

// Image preview modal
Vue.component('image-preview-thumbnail', ImagePreviewThumbnail);

// Buttons
Vue.component('upload-internal-external-file-button', UploadInternalExternalFileButton);
Vue.component('edit-operation-information-items', EditOperationInformationItems);
Vue.component('edit-switch-port-button', EditSwitchPortButton);
Vue.component('task-completed-by', TaskCompletedBy);

Vue.component('order-comment', OrderComment);
Vue.component('order-comment-button-modal', OrderCommentButtonModal);
Vue.component('edit-sales-agent-button', EditSalesAgentButton);
Vue.component('address-query-button', AddressQueryButton);

Vue.component('sales-penetration-steps', SalesPenetrationSteps);

Vue.component('subcontractor-transaction-invoice-calculator', InvoiceCalculator);

Vue.component('export-sales-period', ExportSalesPeriod);
